import axios, { AxiosRequestConfig } from 'axios';
import { API_URL } from '../../configs/env';
import { unauthenticate } from '../../redux-ts';
import { useAppDispatch } from '../../redux-ts/hooks';

export const useHttpClient = () => {
    const dispatch = useAppDispatch();

    // Create an axios instance so interceptors don't stack globally
    const instance = axios.create({
        baseURL: API_URL,
        timeout: 30000,
        // Sends the HttpOnly session cookie set by the API
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            // The API only accepts the session cookie along with this header (CSRF protection)
            'X-Requested-With': 'XMLHttpRequest',
        }
    });

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 401) {
                dispatch(unauthenticate());
            }
            return Promise.reject(error);
        }
    );

    const getOptions = (options: AxiosRequestConfig, useAnonymous: boolean) => ({
        ...options,
        withCredentials: !useAnonymous,
    });

    return {
        get: (url: string, options: AxiosRequestConfig = {}, anon = false) => 
            instance.get(url, getOptions(options, anon)),
        post: (url: string, data: any = {}, options: AxiosRequestConfig = {}, anon = false) => 
            instance.post(url, data, getOptions(options, anon)),
        patch: (url: string, data: any, options: AxiosRequestConfig = {}, anon = false) => 
            instance.patch(url, data, getOptions(options, anon)),
        put: (url: string, data: any, options: AxiosRequestConfig = {}, anon = false) =>
            instance.put(url, data, getOptions(options, anon)),
        delete: (url: string, options: AxiosRequestConfig = {}, anon = false) =>
            instance.delete(url, getOptions(options, anon)),
    };
};
